module.exports = __webpack_public_path__ + "img/Email.54568d42.svg";